import I18n from 'I18n';
import { useCallback } from 'react';
import { ROUTING_SOURCE } from '../../shared/constants/routing-source';
import { HELPDESK } from '../../shared/constants/workspaces';
import { TrackUsageContext } from '../../usage-tracking/contexts/TrackUsageContext';
import AgentSelectItem from '../../users-and-teams/components/AgentSelectItem';
import UsersAndTeamsSelect from '../../users-and-teams/components/UsersAndTeamsSelect';
import { useShowFooter } from '../hooks/useShowFooter';
import { getUsersAndTeams } from '../operators/routingRulesGetters';
import ManageSeatsBanner from './ManageSeatsBanner';
import { RotateOwnerSeatsBanner } from './RotateOwnerSeatsBanner';
import { RoutingMethodTooltip } from './RoutingMethodTooltip';
import RuleBox from './RuleBox';
import UnassignedSeatsBanner from './UnassignedSeatsBanner';
import { jsx as _jsx } from "react/jsx-runtime";
const renderFooter = ({
  objectTypeId,
  onClose,
  routingSource,
  showFooter,
  showManageSeatsFooter
}) => {
  if (!showFooter) {
    return undefined;
  }
  const defaultBanner = showManageSeatsFooter ? /*#__PURE__*/_jsx(ManageSeatsBanner, {
    onClose: onClose
  }) : /*#__PURE__*/_jsx(UnassignedSeatsBanner, {
    onClose: onClose
  });

  // this should be moved out of routing-ui when the UI is able to configure text better
  // if rotate owner & ticket, service & sales seats
  if (routingSource === ROUTING_SOURCE.ROTATE_OWNER) {
    return /*#__PURE__*/_jsx(RotateOwnerSeatsBanner, {
      objectTypeId: objectTypeId,
      onClose: onClose,
      children: defaultBanner
    });
  }
  return defaultBanner;
};
export const RoundRobinRow = ({
  routingRules,
  disabled,
  FormControl,
  inboxId,
  isUngatedForHelpDeskRoutingScopeFiltering,
  objectTypeId,
  onUserOrTeamSelect = () => {},
  routingSource,
  userAndTeamSelectValueComponent,
  usersAndTeamsSelectError,
  trackUsage = () => {},
  showLabel = true,
  workSpace
}) => {
  const {
    showFooter,
    dismissFooter
  } = useShowFooter();
  const {
    teamIds,
    userIds
  } = getUsersAndTeams(routingRules);
  const isNewSeatingModel = isUngatedForHelpDeskRoutingScopeFiltering && (workSpace === HELPDESK || routingSource === ROUTING_SOURCE.HELP_DESK);
  const errorMessage = usersAndTeamsSelectError ? I18n.text('routing-ui.routingRules.roundRobin.selectUserOrTeam') : undefined;
  const ItemComponent = useCallback(props => /*#__PURE__*/_jsx(AgentSelectItem, Object.assign({
    isNewSeatingModel: isNewSeatingModel,
    isOptionItemInDropdown: true
  }, props)), [isNewSeatingModel]);
  return /*#__PURE__*/_jsx(TrackUsageContext.Provider, {
    value: trackUsage,
    children: /*#__PURE__*/_jsx(RuleBox, {
      FormControl: FormControl,
      showLabel: showLabel,
      tooltip: /*#__PURE__*/_jsx(RoutingMethodTooltip, {
        routingRules: routingRules
      }),
      tooltipProps: {
        maxWidth: 271
      },
      children: /*#__PURE__*/_jsx(UsersAndTeamsSelect, {
        "data-test-id": "round-robin-row-select",
        disabled: disabled,
        dropDownFooter: renderFooter({
          objectTypeId,
          onClose: dismissFooter,
          routingSource,
          showFooter,
          showManageSeatsFooter: isNewSeatingModel
        }),
        error: errorMessage,
        handleChange: onUserOrTeamSelect,
        hideUserSectionTooltip: isNewSeatingModel,
        inboxId: inboxId,
        itemComponent: ItemComponent,
        objectTypeId: objectTypeId,
        routingSource: routingSource,
        selectedTeamIds: teamIds,
        selectedUserIds: userIds,
        valueComponent: userAndTeamSelectValueComponent,
        withImmutable: true
      })
    })
  });
};
RoundRobinRow.displayName = 'RoundRobinRow';
export default RoundRobinRow;